const VISIT_HOME_PAGE = 'VISIT_HOME_PAGE';
const VISIT_LOGIN_PAGE = 'VISIT_LOGIN_PAGE';

export {
  VISIT_HOME_PAGE,
  VISIT_LOGIN_PAGE,
};
